// extracted by mini-css-extract-plugin
module.exports = {"minWidth":"style__minWidth__BHQ1B"};